/**
 * Every in-app sales gate books the same team Calendly event. Calendly's round
 * robin picks the host, and the UTM tags tell the team which gate the booking
 * came from.
 */
const SALES_BOOKING_URL =
  'https://calendly.com/d/cnvt-6cm-724/is-jotpsych-right-for-you-and-your-clinic';

export type SalesGateSurface = 'bill-insurance' | 'jotbill' | 'jotaudit';

export function salesBookingUrl(surface: SalesGateSurface): string {
  return `${SALES_BOOKING_URL}?utm_source=app&utm_medium=gate&utm_content=${surface}`;
}
